module.exports = __webpack_public_path__ + "static/media/gif-2.6c9f5836.gif";